
import { defineComponent } from "vue";
import PasswordCreate from "@/client/components/password/Create.vue";

export default defineComponent({
  components: {
    PasswordCreate,
  },
});
